document.addEventListener('DOMContentLoaded',function() {

    const el = document.getElementById('join');

    const init = function() {
        
        const slideCheckbox = el.getElementsByClassName('js-slidecheckbox')[0],
              checkbox = slideCheckbox.getElementsByClassName('js-checkbox')[0];
        
        checkbox.addEventListener('change', function(e) {
            el.classList.remove('fade-in');            
            e.target.checked === true ? el.classList.add('is-true') : el.classList.remove('is-true');

            setTimeout(function() {
                el.classList.add('fade-in');
            }, 10);
        })
    };

    el ? init() : false;

}, false)
